<template>
  <b-tab :title="$t('flexben.beneficiaries.requests')" :active="activeTab === 'requests'" :key="'requests'"
         class="container-bg-white">
    <div class="row px-3 pb-2">
      <div class="col-12">
        <h3 class="mb-0 py-1 pl-0">{{$t("flexben.general.entries")}}</h3>
      </div>
      <div class="col-12 mt-2 sub-tab-table">
        <div class="table-responsive hover-table">
          <table class="table no-min-width">
            <thead>
            <tr>
              <td>{{$t("flexben.beneficiaries.request.number")}}</td>
              <td>{{$t("flexben.beneficiaries.request.placed_on")}}</td>
              <td>{{$t("flexben.general.type")}}</td>
              <td>{{$t("flexben.clients.partial.benefit")}}</td>
              <td>{{$t("flexben.beneficiaries.request.amount")}}</td>
              <td>{{ $t("flexben.requests.table.header.taxes") }}</td>
              <td v-if="tableData.company && tableData.company.cam_budget_taxation">{{ $t("flexben.beneficiary_pages.requests.table.cam_value") }}</td>
              <td>{{$t("flexben.beneficiaries.request.status")}}</td>
              <td>{{$t("flexben.beneficiaries.request.order_number")}}</td>
              <td>{{$t("flexben.beneficiaries.request.order_placed_on")}}</td>
              <td>{{$t("flexben.beneficiaries.request.order_status")}}</td>
            </tr>
            </thead>
            <tbody>
            <template v-if="tableData.data.length >0">
              <tr v-for="(item, index) in tableData.data" :key="index"
                  class="trhover">
                <td>{{item.id}}</td>
                <td>{{moment(item.placed_at, 'DD/MM/YYYY HH:mm')}}</td>
                <td>
                  <img src="@/assets/images/flexben/order/topUp.svg" alt="Top up" v-if="item.type === 'top_up'"/>
                  <img src="@/assets/images/flexben/order/cardRequest.svg" alt="Card request" v-else/>
                </td>
                <td><span :style="{backgroundColor: item.benefit.color}" class="color-bullet"></span> {{
                  item.benefit.name }}
                </td>
                <td>{{ (item.total_value > 0) ? item.total_value+' Lei' : '-' }}</td>
                <td>{{ (item.total_value > 0) ?
                  ((item.total_value_cas+item.total_value_cass+item.total_value_tax).toFixed(2)+' Lei') : '-'}}
                </td>
                <td v-if="tableData.company && tableData.company.cam_budget_taxation">{{ (item.total_value > 0) ? item.value_cam.toFixed(2)+' Lei' : '-' }}</td>
                <td><span class="beneficiary-request-status"
                          :class="'flx-'+item.status">
                {{ $t('flexben.requests.summary.status.' + item.status) }}
              </span></td>
                <td>{{ (item.order_id!==null) ? item.order_number :'-'}}</td>
                <td>{{ (item.order_id!==null) ? moment(item.orders_placed_at, 'DD/MM/YYYY hh:mm') :'-'}}</td>
                <td>
                  <span class="benefit-status m-0"
                        v-if="item.order_id!==null"
                        :class="'benefit-status-'+item.order_status">{{ $t('flexben.general.status_type.' + item.order_status) }}</span>
                  {{ (item.order_id===null) ? '-' :''}}
                </td>
              </tr>
            </template>
            <template v-else>
              <tr class="gri-cell text-center trhover">
                <td colspan="1000" class="text-center">{{ $t("flexben.general.no_results_found") }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 p-0">
        <listPagination
          :currentPage="tableData.current_page"
          :totalItems="tableData.total"
          :startItem="tableData.from"
          :endItem="tableData.to"
          :itemsPerPage="tableData.perPage"
          :defaultPerPage="10"
          @pageChanged="pageChanged"
          @changePerPage="changePerPage"></listPagination>
      </div>
    </div>

  </b-tab>
</template>

<script>
import {BTab} from "bootstrap-vue";
import moment from "moment";

export default {
  name: "TabBeneficiaryHistoryRequests",
  components: {
    "b-tab": BTab,
  },
  props: {
    activeTab: {
      type: String,
      default: '',
      required: true
    },
    tableData: {
      type: Object,
      default: function () {
        return {
          data: [],
          current_page: 1,
          to: 1,
          perPage: 1,
          lastPage: 1,
          total: 1
        };
      },
      required: true
    },
  },
  methods: {
    pageChanged(page) {
      this.$emit('pageChanged', page);
    },
    changePerPage(perPage) {
      this.$emit('changePerPage', perPage, 'request');
    },
    moment(date, format) {
      if (date === null) {
        return '-';
      }
      return moment(date).format(format);
    },
  }
}
</script>
